function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 0c6.62 0 12 5.38 12 12s-5.38 12-12 12S0 18.62 0 12 5.38 0 12 0zm0 2.18c-5.41 0-9.82 4.4-9.82 9.82 0 5.41 4.4 9.82 9.82 9.82 5.41 0 9.82-4.4 9.82-9.82S17.41 2.18 12 2.18zm0 8c.6 0 1.09.49 1.09 1.09v6.55c0 .6-.49 1.09-1.09 1.09s-1.09-.49-1.09-1.09v-6.55c0-.6.49-1.09 1.09-1.09zm0-5.09c.8 0 1.45.65 1.45 1.46a1.451 1.451 0 01-2.9 0c0-.81.65-1.46 1.45-1.46z"
});

function SvgInfoRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "fa4ebdace12661ad735578b0b0ced97d.svg";
export { SvgInfoRound as ReactComponent };